<template>
	<div>
		<modalconfirm ref="modalconfirmPaymentSO" @action="proccessSO"/>
		<div class="text-h5">Approval Refund Sales Order</div>
		<v-card class="mt-3" outlined>
			<v-card-text class="pt-2">
				<v-row>
					<v-col cols="4" sm="4" md="4">
						<div class="text-subtitle-2 font-weight-bold">Kode SO</div>
						<div class="text-body-2">{{ detailSO.so_code }}</div>
					</v-col>
					<!-- <v-col v-if="detailSO" cols="5" sm="5" md="5">
						<div class="text-subtitle-2 font-weight-bold">Warehouse Terakhir</div>
						<div class="text-body-2">{{ detailSO.last_order.warehouse_name }}</div>
					</v-col> -->
					<!-- <v-col v-if="detailSO" cols="3" sm="3" md="3">
						<div class="text-subtitle-2 font-weight-bold">Pemesanan Terakhir</div>
						<div class="text-body-2">{{ detailSO.last_order.last_order_date | tanggal}}</div>
					</v-col> -->

                    <v-col v-if="detailSO" cols="3" sm="3" md="3">
						<div class="text-subtitle-2 font-weight-bold">Tanggal Dibayar</div>
						<div class="text-body-2">{{ detailSO.so_status_paid_datetime | tanggal}}</div>
					</v-col>

                    <v-col v-if="detailSO" cols="3" sm="3" md="3">
						<div class="text-subtitle-2 font-weight-bold">Tanggal Pengajuan Pembatalan</div>
						<div class="text-body-2">{{ detailSO.so_status_approval_refund_datetime | tanggal}}</div>
					</v-col>

					<v-col cols="12" v-if="detailSO">
						<v-row>
							<v-col cols="4" class="py-0">
								<div class="text-subtitle-2 font-weight-bold">Mitra</div>
								<div class="text-body-2">{{ detailSO.customer_network_mid }} - {{ detailSO.customer_name }}</div>
							</v-col>
							<v-col cols="5" class="py-0">
								<div class="text-subtitle-2 font-weight-bold">Alamat</div>
								<div class="text-body-2">{{ addressText(detailSO) }}</div>
							</v-col>
							<!-- <v-col cols="3" class="pb-0">
								<div class="text-subtitle-2 font-weight-bold">Jumlah Transaksi</div>
								<div class="text-body-2">{{detailSO.customer_order_count}}</div>
							</v-col> -->
                            <v-col cols="3" class="pb-0">
								<div class="text-subtitle-2 font-weight-bold">Level Mitra</div>
								<div class="text-body-2">{{detailSO.customer_level.toUpperCase()}} <span v-if="detailSO.customer_level !== 'mb'">({{parseInt(detailSO.customer_order_count) + 1}})</span></div>
							</v-col>
							<v-col cols="4" class="pb-0">
								<div class="text-subtitle-2 font-weight-bold">Pembayaran</div>
								<div class="text-body-2" v-html="detailSO.so_payment_note_full ? detailSO.so_payment_note_full : '-'"></div>
								{{ paymentType() }}
								<div v-if="so_payment_type.includes('bank_transfer') && detailSO.so_payment_type != ''">
									<div v-if="detailSO.so_customer_bank != null">
										{{ detailSO.so_customer_bank.customer_bank_name }} {{ detailSO.so_customer_bank.customer_bank_customer_number }} a/n {{ detailSO.so_customer_bank.customer_bank_customer_name }}
									</div>
								</div>
							</v-col>
							<v-col cols="5" class="pb-0">
								<div class="text-subtitle-2 font-weight-bold">Catatan</div>
								<div class="text-body-2">{{ detailSO.so_note ? detailSO.so_note : '-' }}</div>
							</v-col>
							<!-- <v-col cols="3" class="pb-0">
								<div class="text-subtitle-2 font-weight-bold">Level Mitra</div>
								<div class="text-body-2">{{detailSO.customer_level.toUpperCase()}} <span v-if="detailSO.customer_level !== 'mb'">({{parseInt(detailSO.customer_order_count) + 1}})</span></div>
							</v-col> -->
                            <v-col cols="3" class="pb-0" v-if="detailSO.refund_data">
								<div class="text-subtitle-2 font-weight-bold">Informasi Pengembalian Dana</div>
								<div class="text-body-2">
                                    <div>{{ detailSO.refund_data.refund_data_bank_name }}</div>
                                    <div>{{ detailSO.refund_data.refund_data_bank_customer_name }}</div>
                                    <div>{{ detailSO.refund_data.refund_data_bank_customer_number }}</div>
                                </div>
							</v-col>
						</v-row>
					</v-col>
					<v-col cols="12" >
						<div class="text-subtitle-2 font-weight-bold">Data Order</div>
						<v-simple-table class="pt-3">
							<template v-slot:default>
								<thead class="v-data-table-header">
									<tr>
										<th width="40%" class="text-left">Nama Produk</th>
										<th width="15%" class="text-left">Kode Produk</th>
										<th width="15%" class="text-left">Harga Produk (Rp)</th>
										<th width="15%" class="text-left">Jumlah</th>
										<th width="15%" class="text-left">Sub Total (Rp)</th>
									</tr>
								</thead>
								<tbody v-if="detailSO.so_detail">
									<tr v-for="(product, index) in detailSO.so_detail" :key="index">
										<td> {{ product.so_detail_product_name }} </td>
										<td> {{ product.so_detail_product_code }} </td>
										<td> {{ product.so_detail_product_price | toNumber }} </td>
										<td> {{ product.so_detail_quantity_sold | toNumber }} {{product.so_detail_product_unit}}</td>
										<td> {{ product.so_detail_product_price * product.so_detail_quantity_sold | toNumber }} </td>
									</tr>
								</tbody>
								<tfoot class="v-data-table-footer" v-if="detailSO.so_detail">
									<tr>
										<th width="40%" class="text-left"></th>
										<th width="15%" class="text-left"></th>
										<th width="15%" class="text-left"></th>
										<th width="15%" class="text-left">Tambahan Ongkos Kirim :</th>
										<th width="15%" class="text-left">{{ detailSO.so_delivery_fee | toNumber}}</th>
									</tr>
									<tr>
										<th width="40%" class="text-left"></th>
										<th width="15%" class="text-left"></th>
										<th width="15%" class="text-left"></th>
										<th width="15%" class="text-left">Diskon :</th>
										<th width="15%" class="text-left">{{ discountTotal | toNumber}}</th>
									</tr>
									<tr>
										<th width="40%" class="text-left"></th>
										<th width="15%" class="text-left"></th>
										<th width="15%" class="text-left"></th>
										<th width="15%" class="text-left">Potongan Harga :</th>
										<th width="15%" class="text-left">{{ detailSO.so_rebate_value | toNumber}}</th>
									</tr>
									<tr v-if="detailSO.so_materai_value	> 0">
										<th width="40%" class="text-left"></th>
										<th width="15%" class="text-left"></th>
										<th width="15%" class="text-left"></th>
										<th width="15%" class="text-left">Materai :</th>
										<th width="15%" class="text-left">{{ detailSO.so_materai_value | toNumber}}</th>
									</tr>
									<tr>
										<th width="40%" class="text-left"></th>
										<th width="15%" class="text-left"></th>
										<th width="15%" class="text-left"></th>
										<th width="15%" class="text-left">Total Pembayaran :</th>
										<th width="15%" class="text-left">{{ totalPayment + parseInt(detailSO.so_delivery_fee) - discountTotal - detailSO.so_rebate_value + parseInt(detailSO.so_materai_value) | toNumber}}</th>
									</tr>
								</tfoot>
							</template>
						</v-simple-table>
					</v-col>
				</v-row>
			</v-card-text>
			<v-card-actions class="px-4 pb-4" v-if="userData.user_username !== 'destii'">
				<v-spacer></v-spacer>
				<!-- <v-btn color="grey darken-1" :disabled="!so_code" outlined class="text-capitalize" @click="rejectSO">Tolak</v-btn> -->
				<v-btn color="primary darken-1" :disabled="!so_code || detailSO.so_status != 'approval_refund'" depressed class="text-capitalize" @click="ApprovalRefundSO">Approval Refund</v-btn>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>

import {mapActions, mapState, mapMutations} from 'vuex'

export default {
	inject: ['theme'],
	components: {
	},
	data() {
		return {
			so_code: '',
			soProccess: ''
		}
	},
	props: {
	},
	computed: {
		...mapState('auth', ['userData']),
		...mapState('so', ['detailSO', 'OptionSoToPay', 'responseError', 'response']),

		totalPayment() {
			let total = 0

			this.detailSO.so_detail.forEach( el => {
				total += el.so_detail_quantity_sold * el.so_detail_product_price
			});
			return total
		},
		discountTotal() {
			return this.detailSO.so_discount_percent * this.totalPayment / 100
		},
	},
	methods: {
		...mapActions('so', ['getDetailSO', 'getOptionSoforPay', 'approvalPayment', 'cancelSO', 'approvalRefundPayment']),
		...mapMutations('so', ['saveResponse', 'clearDataSO', 'setDetailSO']),
		...mapMutations(['setOverlay']),

		addressText(value) {
			var data = []
			if (value.customer_address)
				data.push(value.customer_address)
			if (value.customer_subdistrict_name)
				data.push(value.customer_subdistrict_name)
			if (value.customer_city_name)
				data.push(value.customer_city_name)
			if (value.customer_province_name)
				data.push(value.customer_province_name)
			return data.join(', ')
		},
		getDetail(code) {
			if (code) {
				this.getDetailSO(code)
			} else {
				this.setDetailSO({})
			}
		},
		rejectSO(){
			this.soProccess = 'reject'
			this.$refs.modalconfirmPaymentSO.setMessage('Apakah Anda yakin akan membatalkan transaksi ini?')
			this.$refs.modalconfirmPaymentSO.showConfirm()
		},
		ApprovalRefundSO() {
			this.soProccess = 'refund'
			this.$refs.modalconfirmPaymentSO.setMessage('Apakah Anda yakin akan melakukan approval refund pembayaran?')
			this.$refs.modalconfirmPaymentSO.showConfirm()
		},
		async proccessSO() {
			await this.setOverlay(true)
			await this.$refs.modalconfirmPaymentSO.hideConfirm()
			if (this.soProccess == 'refund') {
				let params = await {
					so_id: this.detailSO.so_id
				}
				await this.approvalRefundPayment(params).then(() => {
					if (this.response.code == 200) {
						this.resetForm()
					}
				})
			} else if (this.soProccess == 'reject') {
				// let params = await {
				// 	so_id: this.detailSO.so_id
				// }
				// await this.cancelSO(params).then(() => {
				// 	if (this.response.code == 200.) {
				// 		this.resetForm()
				// 	}
				// })
			}
			await this.setOverlay(false)
		},
		resetForm(){
			this.soProccess = ''
			this.saveResponse({})
			//this.so_code = ''
			//this.setDetailSO('')
			//this.getOptionSoforPay()
			this.getDetail(this.so_code)
		},
		customFilter (item, queryText) {
			const textOne = item.so_code.toLowerCase()
			const textTwo = item.customer_name.toLowerCase()
			const textThree = item.customer_network_code.toLowerCase()
			const searchText = queryText.toLowerCase()

			return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1 || textThree.indexOf(searchText) > -1
		},
		paymentType() {
			if (this.detailSO.so_payment_type) {
				this.so_payment_type = this.detailSO.so_payment_type.split(',')
			} else {
				this.so_payment_type = []
			}
		}
	},
	created() {
		this.$store.dispatch('setPageTitle', `Approval Refund Sales Order`)
		// this.getOptionSoforPay().then(() => {
		// 	if (this.$route.params.code) {
		// 		this.so_code = this.$route.params.code
		// 		this.getDetailSO(this.$route.params.code)
		// 	}
		// })

        if (this.$route.params.code) {
            this.so_code = this.$route.params.code
            this.getDetailSO(this.$route.params.code)
        }
	},
	beforeDestroy(){
		this.clearDataSO()
	},
	watch: {
	}
}
</script>
